import { render, staticRenderFns } from "./quote.vue?vue&type=template&id=09985e5e&scoped=true"
import script from "./quote.vue?vue&type=script&lang=js"
export * from "./quote.vue?vue&type=script&lang=js"
import style0 from "./quote.vue?vue&type=style&index=0&id=09985e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09985e5e",
  null
  
)

export default component.exports